import React from 'react';
import { Helmet } from 'react-helmet';
import { useParams, useHistory } from 'react-router-dom';
import HeroSection, { HeroSectionSubtitle } from 'components/HeroSection';
import PageWrapper from 'components/PageWrapper';
import ApplicationContainer from 'components/ApplicationContainer';
import LearningPathForm from 'routes/EngageAdmin/LearningPath/components/LearningPathForm';
import { useMutation, useQuery } from '@apollo/react-hooks';
import Loader from 'components/Loader';
import Alert from 'components/Alerts';
import { GET_INF_LEARNING_TEMPLATE, CREATE_LEARNING_PATH } from '../graphql';
import { INF_LEARNING_TEMPLATE } from 'utils/consts';

function CopyAdminDashboard() {
  const [alert, setAlert] = React.useState();
  const [loading, setLoading] = React.useState(true);
  const [initialValues, setInitialValues] = React.useState({});
  const { id } = useParams();
  const { push: redirectTo } = useHistory();
  const [createLearningPath] = useMutation(CREATE_LEARNING_PATH);

  useQuery(GET_INF_LEARNING_TEMPLATE, {
    fetchPolicy: 'no-cache',
    variables: { id: id },
    onCompleted: ({ infLearningTemplate }) => {
      setInitialValues(infLearningTemplate);
      setLoading(false);
    },
    onError: err => {
      redirectTo('/engage-admin', { alert: { type: 'warning', message: 'Infinitec Learning Template not found' } });
    },
  });

  const onSubmit = async values => {
    setAlert(null);

    const variables = {
      ...values,
      copiedTemplateId: id,
      modules: values.modules.map(m => ({ module: m.module.id, includeQuiz: m.includeQuiz })),
    };

    try {
      const { data } = await createLearningPath({ variables: variables });

      if (data.createLearningPath.success) {
        redirectTo('/engage-admin', {
          alert: { type: 'success', message: 'Successfully Created Infinitec Learning Template' },
        });
      } else {
        setAlert({ type: 'warning', message: data.createLearningPath.message });
      }
    } catch (e) {
      setAlert({ type: 'warning', message: 'Sorry something went wrong. Please try again.' });
    }
  };

  return (
    <PageWrapper>
      <Helmet>
        <title>Copy Infinitec Learning Template</title>
      </Helmet>
      <HeroSection>
        <h1>ENGAGE Admin Dashboard</h1>
        <HeroSectionSubtitle>Welcome to Infinitec Online Training Administration</HeroSectionSubtitle>
      </HeroSection>
      <ApplicationContainer>
        {alert && <Alert type={alert.type} alertText={alert.message} />}
        {loading ? (
          <Loader />
        ) : (
          <LearningPathForm onSubmit={onSubmit} initialValues={initialValues} currentView={INF_LEARNING_TEMPLATE} />
        )}
      </ApplicationContainer>
    </PageWrapper>
  );
}

export default React.memo(CopyAdminDashboard);
